import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, TextInput, Button, TopToolbar, required, useCreate, useRefresh, FormWithRedirect, SaveButton, useUpdate, useNotify, FunctionField, SelectInput } from 'react-admin';import EditIcon from '@material-ui/icons/Edit';
import Grid from '@mui/material/Grid';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';


import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


import { useTranslate  } from '../common/language';

import { validateMaxLength, validateEmail  } from './../components/Validator';

import { SendEmailIconStatus } from './../components/Emails';
import { targetsEmails, contexts } from './../common/constants';



export const PermissionsList = (props) => {
    
  const translate = useTranslate();  
    
  return (          
          <List {...props} 
            basePath="/users_permissions" 
            resource="users_permissions" 
            sort={{ field: 'id', order: 'ASC' }} 
            actions={<ListActionsUsersPermissionsList associations_id={props.associations_id} context={props.context} />}    
            filter={{ associations_id : props.associations_id, context: props.context }}  
            bulkActionButtons={false}  
            perPage={1000}   
            empty={<ListActionsUsersPermissionsList associations_id={props.associations_id} context={props.context} />} 
            fullWidth
          >        
            <Datagrid sx={{ width: '100%' }} >            
              <TextField fullWidth source="users_email" label={translate('permissions.user')} sortable={false} />
              <FunctionField label={translate('users_permissions.role')} render={record => 
                translate('users_permissions.role_' + record.user_permission_public_id)
              } sortable={false}  />
              <FunctionField label={translate('users_permissions.email_sent')} render={record => 
                <SendEmailIconStatus record={record} target={targetsEmails.NEWADMIN_PERMISSION}  />
              } sortable={false}  />
              <UsersPermissionsEditButton label="" context={props.context} />
              <DeleteButton undoable={false} redirect={props.redirect} label=""/>
            </Datagrid>        
          </List>
  );
    
};

const ListActionsUsersPermissionsList = (props) => {
  const translate = useTranslate(); 
  return (
    <TopToolbar>     
      <UsersPermissionsCreateButton associations_id={props.associations_id} context={props.context} />      
    </TopToolbar>
  );
};


const UsersPermissionsCreateButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [create, { loading }] = useCreate('users_permissions');

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };    

  return (
    <>            
      <Button onClick={handleClick} label={translate('users_permissions.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('users_permissions.create')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('users_permissions.create')}</DialogTitle>

        <FormWithRedirect
          resource="users_permissions"
          save={handleSubmit}
          initialValues={ { associations_id : props.associations_id, context: props.context } }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent edit={false} context={props.context} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const FormContent = (props) => {

  const translate = useTranslate(); 
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  
  return (
    <DialogContent>
      <Grid container spacing={2}>
        <Grid item xs={6}>     
          <TextInput fullWidth source="users_email" label={translate('common.email')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength')),validateEmail()]} disabled={props.edit} />  
        </Grid>         
        <Grid item xs={6}> 
          { props.context == contexts.GESTIOENTITATS ? 
            <SelectInput fullWidth label={translate('users_permissions.role')} source="user_permission_public_id" choices={choicesRoles(translate,props.context)} validate={[required()]} initialValue={ 'ADMIN' } />  
          :
            <SelectInput fullWidth label={translate('users_permissions.role')} source="user_permission_public_id" choices={choicesRoles(translate,props.context)} validate={[required()]} initialValue={ 'TICKETS_BOX_OFFICE' } />  
          }
        </Grid> 
      </Grid>
    </DialogContent>
  );
};


const UsersPermissionsEditButton = ({ ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
    
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  

  const [update, { loading, error }] = useUpdate();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    update(
      { 
        type: 'update', 
        resource: 'users_permissions', 
        payload : { id: values.id, data : values }
      },
      {
        onSuccess: ({ data }) => {
          setShowDialog(false);
          refresh();
        },
        onFailure: ( error ) => {
          notify(error.message, 'error');
        }
      }
    );
  };    

  return (
    <>
      <Button onClick={handleClick} label="" startIcon={<EditIcon />} />

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('users_permissions.edit')}
        className="dialog-md"
        maxWidth="lg"
      >
        <DialogTitle>{translate('users_permissions.edit')}</DialogTitle>

        <FormWithRedirect
          resource="users_permissions"
          save={handleSubmit}
          initialValues={ props.record }
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <FormContent edit={true} context={props.context} />
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

export const choicesRoles = (translate, context = -1) => {

  const allRoles = [
    { id: 'OWNER', name: translate('users_permissions.role_OWNER'), context: contexts.GESTIOENTITATS },
    { id: 'ADMIN', name: translate('users_permissions.role_ADMIN'), context: contexts.GESTIOENTITATS },
    { id: 'ADMIN_CONTACTS', name: translate('users_permissions.role_ADMIN_CONTACTS'), context: contexts.GESTIOENTITATS },
    { id: 'ADMIN_READER', name: translate('users_permissions.role_ADMIN_READER'), context: contexts.GESTIOENTITATS },
    { id: 'ADMIN_PAYMENTS', name: translate('users_permissions.role_ADMIN_PAYMENTS'), context: contexts.GESTIOENTITATS },
    { id: 'ADMIN_CALENDAR_READER', name: translate('users_permissions.role_ADMIN_CALENDAR_READER'), context: contexts.GESTIOENTITATS },
    
    { id: 'TICKETS_BOX_OFFICE', name: translate('users_permissions.role_TICKETS_BOX_OFFICE'), context: contexts.TICKETS },

    // Tickets (exemple context 3)
    /*{ id: 'ADMIN_TICKETS', name: translate('users_permissions.role_ADMIN_TICKETS'), context: 3 },
    { id: 'ADMIN_TICKETS_EVENTS', name: translate('users_permissions.role_ADMIN_TICKETS_EVENTS'), context: 3 },
    { id: 'ADMIN_TICKETS_RESERVATIONS', name: translate('users_permissions.role_ADMIN_TICKETS_RESERVATIONS'), context: 3 },
    { id: 'ADMIN_TICKETS_RESERVATIONS_EVENT', name: translate('users_permissions.role_ADMIN_TICKETS_RESERVATIONS_EVENT'), context: 3 },
    { id: 'ADMIN_TICKETS_VALIDATOR', name: translate('users_permissions.role_ADMIN_TICKETS_VALIDATOR'), context: 3 },
    { id: 'ADMIN_TICKETS_VALIDATOR_EVENT', name: translate('users_permissions.role_ADMIN_TICKETS_VALIDATOR_EVENT'), context: 3 },*/
  ];

  if (context === -1) {
    return allRoles.map(({ id, name }) => ({ id, name }));
  }

  return allRoles
    .filter(role => role.context === -1 || role.context === context)
    .map(({ id, name }) => ({ id, name }));
    
};

const PermissionsStatusTextField = ({ source,record }) => {
  const translate = useTranslate();  
  const textOutput = (record[source] === 0) ? translate('permissions.status0') : translate('permissions.status1');
  return (<span>{textOutput}</span>);
};
